import { MapLocation } from '@/types/location';

export const onSpotLocations: MapLocation[] = [
  {
    id: 9001,
    name: 'Halaqti Barbershop',
    type: 'Barbershop',
    devices: 4,
    coordinates: [24.798578844858127, 46.66657117529893],
    region: 'Riyadh',
    mediaOwner: 'On Spot',
    mediaKind: 'Indoor',
    screenType: 'Landscape Screens',
    orientation: 'Landscape',
    gender: 'Male',
    details: {
      screenDimensions: '0.51m x 0.29m',
      resolution: '1080p (Horizontal)',
      description: 'Indoor LED screen at Halaqti Barbershop',
    },
  },
  {
    id: 9002,
    name: '12 Hub Barbershop',
    type: 'Barbershop',
    devices: 1,
    coordinates: [24.776614042107038, 46.61631709131255],
    region: 'Riyadh',
    mediaOwner: 'On Spot',
    mediaKind: 'Indoor',
    screenType: 'Landscape Screens',
    orientation: 'Landscape',
    gender: 'Male',
    details: {
      screenDimensions: '0.51m x 0.29m',
      resolution: '1080p (Horizontal)',
      description: 'Indoor LED screen at 12 Hub Barbershop',
    },
  },
  {
    id: 9003,
    name: 'A+ Barbershop',
    type: 'Barbershop',
    devices: 2,
    coordinates: [24.822950932881362, 46.62928355239099],
    region: 'Riyadh',
    mediaOwner: 'On Spot',
    mediaKind: 'Indoor',
    screenType: 'Landscape Screens',
    orientation: 'Landscape',
    gender: 'Male',
    details: {
      screenDimensions: '0.51m x 0.29m',
      resolution: '1080p (Horizontal)',
      description: 'Indoor LED screen at A+ Barbershop',
    },
  },
  {
    id: 9004,
    name: 'حلاق المستوى الراقي',
    type: 'Barbershop',
    devices: 6,
    coordinates: [24.809732001698002, 46.61268120582578],
    region: 'Riyadh',
    mediaOwner: 'On Spot',
    mediaKind: 'Indoor',
    screenType: 'Landscape Screens',
    orientation: 'Landscape',
    gender: 'Male',
    details: {
      screenDimensions: '0.51m x 0.29m',
      resolution: '1080p (Horizontal)',
      description: 'Indoor LED screen at حلاق المستوى الراقي',
    },
  },
  {
    id: 9005,
    name: 'Care Lounge',
    type: 'Barbershop',
    devices: 6,
    coordinates: [24.810815831944307, 46.59640204799713],
    region: 'Riyadh',
    mediaOwner: 'On Spot',
    mediaKind: 'Indoor',
    screenType: 'Landscape Screens',
    orientation: 'Landscape',
    gender: 'Male',
    details: {
      screenDimensions: '0.51m x 0.29m',
      resolution: '1080p (Horizontal)',
      description: 'Indoor LED screen at Care Lounge',
    },
  },
  {
    id: 9006,
    name: 'Unique Details Barber Shop',
    type: 'Barbershop',
    devices: 2,
    coordinates: [24.87210318355991, 46.65411773974223],
    region: 'Riyadh',
    mediaOwner: 'On Spot',
    mediaKind: 'Indoor',
    screenType: 'Landscape Screens',
    orientation: 'Landscape',
    gender: 'Male',
    details: {
      screenDimensions: '0.51m x 0.29m',
      resolution: '1080p (Horizontal)',
      description: 'Indoor LED screen at Unique Details Barber Shop',
    },
  },
  {
    id: 9007,
    name: 'Unified Creativity Salon',
    type: 'Salon',
    devices: 2,
    coordinates: [24.790011226790373, 46.62231471861976],
    region: 'Riyadh',
    mediaOwner: 'On Spot',
    mediaKind: 'Indoor',
    screenType: 'Landscape Screens',
    orientation: 'Landscape',
    gender: 'Male',
    details: {
      screenDimensions: '0.51m x 0.29m',
      resolution: '1080p (Horizontal)',
      description: 'Indoor LED screen at Unified Creativity Salon',
    },
  },
  {
    id: 9008,
    name: 'Nai Nail Saloon',
    type: 'Salon',
    devices: 1,
    coordinates: [24.76308917065362, 46.70283926080663],
    region: 'Riyadh',
    mediaOwner: 'On Spot',
    mediaKind: 'Indoor',
    screenType: 'Landscape Screens',
    orientation: 'Landscape',
    gender: 'Female',
    details: {
      screenDimensions: '0.51m x 0.29m',
      resolution: '1080p (Horizontal)',
      description: 'Indoor LED screen at Nai Nail Saloon',
    },
  },
  {
    id: 9009,
    name: 'Trendy Cut 1',
    type: 'Barbershop',
    devices: 1,
    coordinates: [24.780582542234214, 46.58308442036645],
    region: 'Riyadh',
    mediaOwner: 'On Spot',
    mediaKind: 'Indoor',
    screenType: 'Portrait Screens',
    orientation: 'Portrait',
    gender: 'Male',
    details: {
      screenDimensions: '0.29m x 0.51m',
      resolution: '1080p (Vertical)',
      description: 'Indoor LED screen at Trendy Cut 1',
    },
  },
  {
    id: 9010,
    name: 'Trendy Cut 2',
    type: 'Barbershop',
    devices: 1,
    coordinates: [24.841863814636305, 46.60203987688566],
    region: 'Riyadh',
    mediaOwner: 'On Spot',
    mediaKind: 'Indoor',
    screenType: 'Portrait Screens',
    orientation: 'Portrait',
    gender: 'Male',
    details: {
      screenDimensions: '0.29m x 0.51m',
      resolution: '1080p (Vertical)',
      description: 'Indoor LED screen at Trendy Cut 2',
    },
  },
  {
    id: 9011,
    name: '66 Barbershop',
    type: 'Barbershop',
    devices: 1,
    coordinates: [24.886206756800632, 46.61662293162257],
    region: 'Riyadh',
    mediaOwner: 'On Spot',
    mediaKind: 'Indoor',
    screenType: 'Portrait Screens',
    orientation: 'Portrait',
    gender: 'Male',
    details: {
      screenDimensions: '0.29m x 0.51m',
      resolution: '1080p (Vertical)',
      description: 'Indoor LED screen at 66 Barbershop',
    },
  },
  {
    id: 9012,
    name: 'Happiest Moments BarberShop',
    type: 'Barbershop',
    devices: 1,
    coordinates: [24.83173640923808, 46.68008704780653],
    region: 'Riyadh',
    mediaOwner: 'On Spot',
    mediaKind: 'Indoor',
    screenType: 'Portrait Screens',
    orientation: 'Portrait',
    gender: 'Male',
    details: {
      screenDimensions: '0.29m x 0.51m',
      resolution: '1080p (Vertical)',
      description: 'Indoor LED screen at Happiest Moments BarberShop',
    },
  },
  {
    id: 9013,
    name: 'Luxury Zone Barbershop',
    type: 'Barbershop',
    devices: 1,
    coordinates: [24.81045404300026, 46.60010754174156],
    region: 'Riyadh',
    mediaOwner: 'On Spot',
    mediaKind: 'Indoor',
    screenType: 'Portrait Screens',
    orientation: 'Portrait',
    gender: 'Male',
    details: {
      screenDimensions: '0.29m x 0.51m',
      resolution: '1080p (Vertical)',
      description: 'Indoor LED screen at Luxury Zone Barbershop',
    },
  },
  {
    id: 9014,
    name: 'Salon Qimam Bairut',
    type: 'Salon',
    devices: 1,
    coordinates: [24.82905092279063, 46.59080520773273],
    region: 'Riyadh',
    mediaOwner: 'On Spot',
    mediaKind: 'Indoor',
    screenType: 'Portrait Screens',
    orientation: 'Portrait',
    gender: 'Male',
    details: {
      screenDimensions: '0.29m x 0.51m',
      resolution: '1080p (Vertical)',
      description: 'Indoor LED screen at Salon Qimam Bairut',
    },
  },
  {
    id: 9015,
    name: 'حلاق فن مصر',
    type: 'Barbershop',
    devices: 1,
    coordinates: [24.81558487658866, 46.65611123190097],
    region: 'Riyadh',
    mediaOwner: 'On Spot',
    mediaKind: 'Indoor',
    screenType: 'Portrait Screens',
    orientation: 'Portrait',
    gender: 'Male',
    details: {
      screenDimensions: '0.29m x 0.51m',
      resolution: '1080p (Vertical)',
      description: 'Indoor LED screen at حلاق فن مصر',
    },
  },
];
